export enum AuthRegisterActions {
  CHANGE_COUNTRY,
  SEND_SMS,
}
